import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { isTestEnv } from '@/utils/environment';
import { Checkbox } from '@/components/ui/checkbox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Control } from 'react-hook-form';
import { RegistrationFormData } from './schema';

interface RecaptchaInputProps {
  control: Control<RegistrationFormData>;
}

const RecaptchaInput: React.FC<RecaptchaInputProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="recaptchaToken"
      render={({ field }) => (
        <FormItem>
          {isTestEnv() ? (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0">
              <FormControl>
                <Checkbox
                  id="recaptcha-checkbox"
                  onCheckedChange={checked => {
                    field.onChange(checked ? 'test-token' : '');
                  }}
                />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel htmlFor="recaptcha-checkbox">
                  I am not a robot (Test Mode)
                </FormLabel>
              </div>
            </FormItem>
          ) : (
            <FormControl>
              <ReCAPTCHA
                sitekey={
                  document
                    .querySelector('meta[name="recaptcha-site-key"]')
                    ?.getAttribute('content') || ''
                }
                onChange={token => field.onChange(token || '')}
                onExpired={() => field.onChange('')}
              />
            </FormControl>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default RecaptchaInput;
